export default __webpack_public_path__ + "static/media/Decoding.ac9901ad.png";